export default __webpack_public_path__ + "static/techguru-example1-93a09b6775b47a6a88ecc90e4f0d4ae0.png";